import Layout from '@/components/Layout';
import { PageHeader } from '@/components/PageHeader';
import { AutomationsContent } from '@/components/automations/AutomationsContent';
import { AutomationBuilderDialog } from '@/components/automations/AutomationBuilderDialog';
import { DeleteAutomationDialog } from '@/components/automations/DeleteAutomationDialog';
import { RunHistoryDialog } from '@/components/automations/RunHistoryDialog';
import { useAutomationsPage } from '@/hooks/use-automations';

export default function Automations() {
  const {
    rules,
    isLoading,
    error,
    canManageAutomations,
    templates,
    templateNameById,
    isBuilderOpen,
    editingRule,
    form,
    setForm,
    deleteTarget,
    setDeleteTarget,
    runsRule,
    setRunsRule,
    runs,
    isRunsLoading,
    runsError,
    isSaving,
    canSave,
    openCreate,
    openEdit,
    closeBuilder,
    updateCondition,
    changeConditionField,
    addCondition,
    removeCondition,
    handleSave,
    handleToggle,
    handleDelete,
  } = useAutomationsPage();

  if (!canManageAutomations) {
    return (
      <Layout>
        <div className="container mx-auto px-4 py-8">
          <PageHeader
            title="Automations"
            description="Set up if-then rules that run automatically"
          />
          <p className="mt-6 text-sm text-muted-foreground">
            Only company owners and admins can manage automations.
          </p>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <AutomationsContent
        rules={rules}
        isLoading={isLoading}
        error={error}
        templateNameById={templateNameById}
        onCreate={openCreate}
        onEdit={openEdit}
        onShowRuns={setRunsRule}
        onRequestDelete={setDeleteTarget}
        onToggleActive={handleToggle}
      />

      <AutomationBuilderDialog
        isOpen={isBuilderOpen}
        editingRule={editingRule}
        form={form}
        templates={templates}
        isSaving={isSaving}
        canSave={canSave}
        onOpenChange={(open) => {
          if (!open) closeBuilder();
        }}
        onFormChange={setForm}
        onUpdateCondition={updateCondition}
        onChangeConditionField={changeConditionField}
        onAddCondition={addCondition}
        onRemoveCondition={removeCondition}
        onSave={handleSave}
      />

      <DeleteAutomationDialog
        target={deleteTarget}
        onOpenChange={(open) => {
          if (!open) setDeleteTarget(null);
        }}
        onConfirmDelete={handleDelete}
      />

      <RunHistoryDialog
        rule={runsRule}
        runs={runs}
        isLoading={isRunsLoading}
        error={runsError}
        onOpenChange={(open) => {
          if (!open) setRunsRule(null);
        }}
      />
    </Layout>
  );
}
